import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type ScormContentCardFragment = { id: string, name: string, type: Types.ResourceTypeEnum, duration: number, description?: string | null, status: Types.ResourceStatusEnum, objective?: string | null, cover?: { name: string, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum } | null, scormProperties?: { schemaVersion: string, masteryScore?: number | null, resourceHref: string } | null, performance?: { id: string, status: Types.PerformanceStatusEnum, progress: number, estimatedTimeSpent?: number | null } | null, bookmark?: { id: string } | null };


export type ScormContentCardFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type ScormContentCardWithUserPerformanceFragment = { id: string, name: string, type: Types.ResourceTypeEnum, duration: number, description?: string | null, status: Types.ResourceStatusEnum, objective?: string | null, cover?: { name: string, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum } | null, scormProperties?: { schemaVersion: string, masteryScore?: number | null, resourceHref: string } | null, performance?: { id: string, status: Types.PerformanceStatusEnum, estimatedTimeSpent?: number | null, enrolmentInfo?: { dueDate?: string | null } | null } | null, bookmark?: { id: string } | null };


export type ScormContentCardWithUserPerformanceFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const ScormContentCardFragmentDoc = /*#__PURE__*/ gql`
    fragment ScormContentCard on ScormContentType {
  id
  name
  type
  duration
  description
  status
  objective
  cover {
    name
    url
    size
    mimeType
    mediaId
    kind
  }
  scormProperties {
    schemaVersion
    masteryScore
    resourceHref
  }
  performance {
    id
    status
    progress
    estimatedTimeSpent
  }
  bookmark {
    id
  }
}
    `;
export const ScormContentCardWithUserPerformanceFragmentDoc = /*#__PURE__*/ gql`
    fragment ScormContentCardWithUserPerformance on ScormContentType {
  id
  name
  type
  duration
  description
  status
  objective
  cover {
    name
    url
    size
    mimeType
    mediaId
    kind
  }
  scormProperties {
    schemaVersion
    masteryScore
    resourceHref
  }
  performance(userId: $userId) {
    id
    status
    estimatedTimeSpent
    enrolmentInfo {
      dueDate
    }
  }
  bookmark {
    id
  }
}
    `;